import { SHA256 } from 'crypto-js';

export const generateUniqEventId = (eventName: string, userId: string, eventInstanceId: string) => {
  const hash = SHA256(`${eventName}-${userId}-${eventInstanceId}`).toString();
  return hash;
};
